import {action, computed, observable, makeObservable, runInAction} from 'mobx';
import {enumToValues} from '@netx/core-next/utils/enum';
import {RuleModel} from '../baseModel';
import {
	FileSizeType,
	FileSizeMetric,
	SearchTypeFileSize,
	TSearchTypeFileSize,
} from './constants';
import {fileSizeRuleDefaults} from './defaults';
import type {FileSizeRule} from './types';
import {validateFileSizeRule} from './validate';

export class FileSizeRuleModel
	extends RuleModel<TSearchTypeFileSize>
	implements FileSizeRule
{
	readonly elementType = SearchTypeFileSize;
	elementSubType1: FileSizeType = fileSizeRuleDefaults.elementSubType1;
	elementSubType2: FileSizeMetric = fileSizeRuleDefaults.elementSubType2;
	elementValue1: number = fileSizeRuleDefaults.elementValue1;
	elementValue2: '' = fileSizeRuleDefaults.elementValue2;
	elementValue3: '' = fileSizeRuleDefaults.elementValue3;

	get elementSubType1Options() {
		return enumToValues(FileSizeType);
	}

	get elementSubType2Options() {
		return enumToValues(FileSizeMetric);
	}

	get isValid() {
		const validation = validateFileSizeRule(this);
		this.setValidationErrors(this.dirty && validation ? validation : undefined);
		if (!validation) return true;
		return false;
	}

	constructor(params?: Partial<Omit<FileSizeRule, 'elementType'>>) {
		super();

		runInAction(() => {
			Object.assign(this, {...fileSizeRuleDefaults, ...params});
		});

		makeObservable(this, {
			elementSubType1: observable,
			elementSubType1Options: computed,
			elementSubType2: observable,
			elementSubType2Options: computed,
			elementValue1: observable,
			isValid: computed,
			setElementSubType1: action,
			setElementSubType2: action,
			setElementValue1: action,
		});
	}

	/**
	 * Set file size compute type
	 * @param elementSubType1 FileSizeType
	 */
	setElementSubType1(elementSubType1: FileSizeType) {
		this.elementSubType1 = elementSubType1;
	}

	/**
	 * Set file size metric
	 * @param elementSubType2 FileSizeMetric
	 */
	setElementSubType2(elementSubType2: FileSizeMetric) {
		this.elementSubType2 = elementSubType2;
	}

	/**
	 * Set file size
	 * @param elementValue1 file size
	 */
	setElementValue1(elementValue1: number) {
		this.elementValue1 = elementValue1;
		this.dirty = true;
	}

	/** stubbed */
	setElementValue2() {}

	/** stubbed */
	setElementValue3() {}
}

export default FileSizeRuleModel;
